export default "__VITE_ASSET__ByxYLvQM__"